module.exports = __webpack_public_path__ + "img/diamante.77427ab1.png";